import React from "react";
import Layout from "../../layouts/landing";
import Hero from "../../components/templates/landing/Preapproved/Hero";
import Faq from "../../components/templates/landing/Preapproved/Faq";
import ClosingCta from "../../components/templates/landing/Preapproved/ClosingCta";
import RealLife from "../../components/templates/landing/CashFast/RealLife";
import Stories from "../../components/templates/landing/CashFast/Stories";
import PageFooter from "../../components/templates/landing/InstantCash/PageFooter";
import Disclaimer from "../../components/templates/landing/InstantCash/Disclaimer";
import { tribesConfig } from "../../app.config";
import { Theme } from "./styles-preapproved";

import rayPorch from "../../assets/landing/v3-ray-porch.jpg";
import story1 from "../../assets/landing/v2-story-1.jpg";
import story2 from "../../assets/landing/v2-story-2.jpg";
import story3 from "../../assets/landing/v2-story-3.jpg";

const COMPANY = "Patria Lending";
/* The reference links "click here" at the tribe's own about page rather than a
 * route in this app, so it is built from the tenant's configured website.
 *
 * Read from the env var rather than tribesConfig.website: that one is
 * String(process.env...), and String(undefined) is the string "undefined", so an
 * unset var produced the truthy "https://undefined/about" and Disclaimer
 * rendered the sentence with a dead link instead of dropping it. process.env is
 * undefined or "" when absent, which is falsy. */
const tribeWebsite = process.env.REACT_APP_TRIBE_WEBSITE?.trim();
const tribeInfoUrl = tribeWebsite
  ? `https://${tribeWebsite.replace(/^https?:\/\//, "")}/about`
  : undefined;

const metrics = [
  { value: "$2,000", label: "Up to" },
  { value: "0", label: "Credit hit" },
  { value: "30 days", label: "To claim" },
];

const stories = [
  {
    quote: "The letter came Tuesday. Money was in my account Wednesday.",
    name: "Marcus D.",
    place: "Tulsa, OK",
    tag: "Auto repair",
    color: "var(--brand-red)",
    image: story1,
    alt: "A man smiling outside an auto repair shop",
  },
  {
    quote: "I nearly threw the envelope out. So glad I didn't — it was real.",
    name: "Elena R.",
    place: "Phoenix, AZ",
    tag: "Appliance",
    color: "var(--brand-green-deep)",
    image: story2,
    alt: "A woman smiling at her kitchen table",
  },
  {
    quote: "Answered a few questions and was done. No games.",
    name: "Aisha K.",
    place: "Atlanta, GA",
    tag: "Medical",
    color: "var(--brand-blue-deep)",
    image: story3,
    alt: "A healthcare worker smiling on a city street",
  },
];

const faq = [
  {
    q: "Is this letter really from Patria?",
    a: "Yes. We mailed it based on a soft pre-screen. It has no impact on your credit score. If you'd like to verify, call the number on the back of the letter.",
  },
  {
    q: "Is my offer guaranteed?",
    a: "Your preapproval reserves the amount and rate for 30 days. Final approval requires verifying the info you provide.",
  },
  {
    q: "What if I lost my letter?",
    a: "No problem — we look you up automatically from the info you enter. You don't need the letter in hand.",
  },
  {
    q: "How fast will I get the money?",
    a: "Once approved, deposits often land in minutes and typically no later than the next business day.",
  },
];

const Preapproved = () => {
  return (
    <Theme>
      <Layout
        showApplyCta
        ctaLabel="Check status"
        tagline="Safe. Fast. Secure."
        footer={<PageFooter companyName={COMPANY} tone="dark" />}
      >
        <Hero directMailUrl={process.env.REACT_APP_DIRECT_MAIL_URL} />
        <RealLife
          className="section-lp3-why"
          image={rayPorch}
          alt="A Patria customer on his porch at golden hour"
          kicker="Ray, 34 · Denver"
          quote={`"The letter said 60 seconds. It really was."`}
          badge="Approved in 47 seconds"
          badgeBg="var(--brand-ink)"
          metrics={metrics}
          eyebrow="Why we sent you a letter"
          heading={
            <>
              Because you <span className="accent">qualified</span>.
            </>
          }
          copy="We pre-screened you based on a soft check — no impact to your credit score. Your offer, amount, and rate are already reserved in your name."
        />
        <Stories
          className="section-lp3-stories"
          stories={stories}
          eyebrow="From other letter-holders"
          heading="They opened the envelope. Here's what happened next."
        />
        <Faq items={faq} />
        <ClosingCta />
        <Disclaimer
          companyName={COMPANY}
          tribe={`${tribesConfig.tribalLands} Tribe`}
          moreInfoUrl={tribeInfoUrl}
        />
      </Layout>
    </Theme>
  );
};

export default Preapproved;
